import { useQuery } from '@tanstack/react-query';

import { StudentDirectoryFilters, studentDirectoryApi } from '@/services';

export const studentDirectoryKeys = {
  all: ['student-directory'] as const,
  list: (filters: StudentDirectoryFilters) => ['student-directory', 'list', filters] as const,
  arriving: (filters: StudentDirectoryFilters) => ['student-directory', 'arriving', filters] as const,
  detail: (id: string | undefined) => ['student-directory', 'detail', id] as const,
};

export function useStudentDirectoryQuery(filters: StudentDirectoryFilters = {}) {
  return useQuery({
    queryKey: studentDirectoryKeys.list(filters),
    queryFn: () => studentDirectoryApi.list(filters),
  });
}

export function useStudentDirectoryArrivingQuery(filters: StudentDirectoryFilters = {}) {
  return useQuery({
    queryKey: studentDirectoryKeys.arriving(filters),
    queryFn: () => studentDirectoryApi.arriving(filters),
  });
}

export function useStudentDirectoryDetailQuery(id: string | undefined) {
  return useQuery({
    queryKey: studentDirectoryKeys.detail(id),
    queryFn: () => studentDirectoryApi.detail(id as string),
    enabled: Boolean(id),
  });
}
